import type {
  DeviceTrailListRequestQuery,
  DeviceTrailListResponse
} from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

const useDeviceSigns = (
  query?: DeviceTrailListRequestQuery,
  enabled?: boolean
) => {
  const { isLoading, data, refetch } = useQuery<GetListQueryResponse>(
    `devices-signs-${JSON.stringify(query)}`,
    () => getJSON({ url: getListQuery(query) }),
    {
      enabled
    }
  )

  return {
    signs: data?.result,
    count: data?.count,
    isLoading,
    refetch
  }
}

export type GetListQueryResponse = {
  result?: DeviceTrailListResponse[]
  count?: number
}

const getListQuery = (query?: DeviceTrailListRequestQuery) =>
  `/api/list/device-trails/?${getQueryParams(query || {})}`

export default useDeviceSigns
